import { useQuery } from '@tanstack/vue-query';

import capitalMarketsService from '../services/capitalMarketsService';

export default function useSecuritizations() {
  return useQuery({
    queryFn: () => capitalMarketsService.getSecuritizations(),
    queryKey: ['securitizations'],
    retry: 2,
    retryDelay: 1000,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
